export type MenuItem = {
    label: string;
    url: string;
    permission: {resource: string; scope: string};
    /** Conservé pour le contrôle d'accès de la route, absent du menu. */
    hidden?: boolean;
    icon?: string;
};

export const menuItems: MenuItem[] = [
    {
        label: "applicationMenu.menuItem.data4home",
        url: "/address",
        permission: {resource: "vision_data4home", scope: "view"},
        icon: "data4home",
    },
    {
        label: "applicationMenu.menuItem.data4home2",
        url: "/address/legacy",
        permission: {resource: "vision_data4home", scope: "view"},
        hidden: true,
        icon: "data4home",
    },
    {
        label: "applicationMenu.menuItem.addressBulk",
        url: "/address/bulk",
        permission: {resource: "vision_data4home-adress_bulk", scope: "view"},
        icon: "addressBulk",
    },
    {
        label: "applicationMenu.menuItem.riskEditor",
        url: "/risk-editor",
        permission: {resource: "vision_data4home:risk_editor", scope: "view"},
        icon: "riskEditor",
    },
    {
        label: "applicationMenu.menuItem.exclusionZones",
        url: "/exclusion-zone",
        permission: {resource: "vision_data4home-settings", scope: "view"},
        icon: "exclusionZone",
    },
    {
        label: "applicationMenu.menuItem.data4weather",
        url: "/weather",
        permission: {resource: "vision_weather", scope: "view"},
        icon: "data4weather",
    },
]